import { IonBackButton, IonButtons, IonContent, IonHeader, IonLabel, IonPage, IonSegment, IonSegmentButton, IonTitle, IonToolbar } from '@ionic/react'
import React from 'react'
import BalanceSheet from './BalanceSheet'
import ProfitLossGraph from '../Graphs/ProfitLossGraph'
import ProfitLoss from './ProfitLoss'
import SalesGraph from '../Graphs/SalesGraph'
import Sales from './Sales'
import Purchase from './Purchase'
import Adjustments from './Adjustments'
import moment from 'moment'
import DateTimePicker from '../../components/DateTimePicker'


const Reports = () => {
    const [segment, setSegment] = React.useState('sales')
    const [from, setFrom] = React.useState(moment().subtract(1, 'month').format('YYYY-MM-DD'))
    const [to, setTo] = React.useState(moment().format('YYYY-MM-DD'));

    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonBackButton />
                    </IonButtons>
                    <IonTitle>Reports</IonTitle>

                    <IonButtons slot="end">
                        <DateTimePicker from={from} to={to} setFrom={setFrom} setTo={setTo} />
                    </IonButtons>
                </IonToolbar>
            </IonHeader>
            <IonContent class='ion-padding'>

                <IonSegment value={segment} onIonChange={e => setSegment(e.detail.value)}>
                    <IonSegmentButton value="pnl">
                        <IonLabel>Profit/Loss</IonLabel>
                    </IonSegmentButton>
                    <IonSegmentButton value="sales">
                        <IonLabel>Sales</IonLabel>
                    </IonSegmentButton>
                    <IonSegmentButton value="purchase">
                        <IonLabel>Purchase</IonLabel>
                    </IonSegmentButton>
                    <IonSegmentButton value="adj">
                        <IonLabel>Adjustments</IonLabel>
                    </IonSegmentButton>
                </IonSegment>
                {
                    segment === 'pnl' && <ProfitLoss />
                }
                {
                    segment === 'sales' && <Sales from={from} to={to} />
                }
                {
                    segment === 'purchase' && <Purchase from={from} to={to} />
                }
                {
                    segment === 'adj' && <Adjustments from={from} to={to} />
                }

            </IonContent>
        </IonPage>
    )
}

export default Reports
